import { useState } from 'react';
import { useQuery } from 'react-query';
import { getMerchantLogo } from '@frontend/api-payments';
import { paymentsQueryKeys } from '@frontend/payments-hooks';

export const useMerchantLogo = (locationId: string | undefined) => {
  const [fetchMerchantLogo, setFetchMerchantLogo] = useState(false);

  const { data: logo, isFetched: isLogoFetched } = useQuery({
    queryKey: [locationId, paymentsQueryKeys.merchantLogo],
    queryFn: () => getMerchantLogo(locationId ?? ''),
    enabled: fetchMerchantLogo && !!locationId,
    retry: 1,
    refetchOnWindowFocus: false,
  });
  return { fetchMerchantLogo: () => setFetchMerchantLogo(true), logo, isLogoFetched };
};
